import { Button } from "@mui/material";
import axios from "axios";
import { Root } from "../state/types";
import { useSelector } from "react-redux";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { QRCode } from "react-qrcode-logo";
import { MutableRefObject, useRef, useState } from "react";
import DownloadUpgradeDialog from "./DownloadUpgradeDialog";

const SaveQrCode = () => {
    const qrData = useSelector((state: Root) => state.qrData);
    const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);
	const ref = useRef<QRCode>()

    const onDownload = async () => {
        ref.current?.download('jpg', `QRCompose-free`);
        setOpenUpgradeDialog(true)
    }
    
    return(
        <>
            <QRCode
                ref={ref as MutableRefObject<QRCode>}
                value={qrData.qrText}
                size={1000}
                fgColor={qrData.qrColour}
                bgColor={qrData.bgColour}
                logoImage={qrData.logoSrc}
                logoPadding={4}
                style={{display: 'none'}}
            />
            <Button
                variant="contained"
                onClick={onDownload}
                sx={{ marginTop: 2, textTransform: 'none', backgroundColor: '#000', color: '#fff' }}
                disabled={qrData.qrText === ""}
            >
                Download QR Code <SaveAltIcon sx={{marginLeft: 1}}/>
            </Button>
            <DownloadUpgradeDialog open={openUpgradeDialog} onClose={() => setOpenUpgradeDialog(false)} />
        </>
    )
}

export default SaveQrCode;